import React, { useEffect, useState } from "react";
import { errorHandler } from "../../utility/errorHandler";

type IconProps = {
  name: string;
  className?: string;
  width?: string;
  height?: string;
  fill?: string;
};

const Icons: React.FC<IconProps> = ({
  name,
  className = "",
  width = "21px",
  height = "21px",
  fill,
}) => {
  const [svgContent, setSvgContent] = useState<string>("");

  useEffect(() => {
    const iconPath = `${process.env.PUBLIC_URL}/assets/icons/${name}.svg`;

    fetch(iconPath)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Failed to load ${iconPath}`);
        }
        return response.text();
      })
      .then((data) => {
        const parser = new DOMParser();
        const svgDoc = parser.parseFromString(data, "image/svg+xml");
        const svgElement = svgDoc.querySelector("svg");

        if (svgElement) {
          svgElement.setAttribute("width", width);
          svgElement.setAttribute("height", height);
          if (fill) {
            svgElement.setAttribute("fill", fill);
          }
          setSvgContent(svgElement.outerHTML);
        }
      })
      .catch((e) => {
        errorHandler("error", e);
      });
  }, [name, width, height, fill]);

  if (!svgContent) return null;

  return (
    <span
      className={className}
      dangerouslySetInnerHTML={{ __html: svgContent }}
    />
  );
};

export default Icons;
